var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _g, _line, _g2, _line2, _g3, _line3, _g4, _line4, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadguy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 159,
    viewBox: "0 0 94 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.8892 158.779C73.9473 158.779 93.4502 156.517 93.4502 153.727C93.4502 150.937 73.9473 148.675 49.8892 148.675C25.8311 148.675 6.32812 150.937 6.32812 153.727C6.32812 156.517 25.8311 158.779 49.8892 158.779Z",
    fill: "#D5E6FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8892 158.779C73.9473 158.779 93.4502 156.517 93.4502 153.727C93.4502 150.937 73.9473 148.675 49.8892 148.675C25.8311 148.675 6.32812 150.937 6.32812 153.727C6.32812 156.517 25.8311 158.779 49.8892 158.779Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7555 32.4727C78.3399 29.3607 77.9924 26.1456 76.7567 23.2303C75.5211 20.3151 73.4522 17.8296 70.8096 16.0854C68.1669 14.3413 65.0682 13.4162 61.9019 13.4262C58.7356 13.4362 55.6427 14.3808 53.0111 16.1415C51.0998 11.4954 47.6353 7.65661 43.2088 5.28039C38.7824 2.90417 33.6685 2.13781 28.74 3.11213C23.8114 4.08644 19.3738 6.74103 16.1845 10.6228C12.9952 14.5046 11.252 19.3729 11.2523 24.3968C11.2523 24.6658 11.2523 24.9306 11.2523 25.1954C8.13651 26.0834 5.42074 28.0156 3.56039 30.6682C1.70003 33.3207 0.808225 36.5322 1.0345 39.7641C1.26078 42.9961 2.59138 46.052 4.80319 48.4194C7.015 50.7868 9.97353 52.3218 13.1827 52.767V52.9165H77.0637C79.659 52.8264 82.1235 51.7546 83.959 49.9175C85.7945 48.0805 86.8643 45.6151 86.9522 43.0197C87.04 40.4243 86.1394 37.8922 84.4323 35.9352C82.7252 33.9783 80.3389 32.7422 77.7555 32.4769V32.4727Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7555 30.5508C78.3399 27.4389 77.9924 24.2237 76.7567 21.3084C75.5211 18.3932 73.4522 15.9077 70.8096 14.1636C68.1669 12.4194 65.0682 11.4944 61.9019 11.5043C58.7356 11.5143 55.6427 12.4589 53.0111 14.2197C51.0999 9.57386 47.6358 5.73529 43.2098 3.35902C38.7838 0.982754 33.6703 0.21608 28.7421 1.18984C23.8138 2.1636 19.3762 4.81743 16.1866 8.69844C12.9969 12.5795 11.253 17.4471 11.2523 22.4706C11.2523 22.7397 11.2523 23.0045 11.2523 23.2692C8.13651 24.1572 5.42074 26.0895 3.56039 28.742C1.70003 31.3945 0.808225 34.606 1.0345 37.838C1.26078 41.07 2.59138 44.1259 4.80319 46.4933C7.015 48.8607 9.97353 50.3957 13.1827 50.8408V50.9903H77.0637C79.659 50.9003 82.1235 49.8285 83.959 47.9914C85.7945 46.1543 86.8643 43.689 86.9522 41.0936C87.04 38.4981 86.1394 35.9661 84.4323 34.0091C82.7252 32.0521 80.3389 30.8161 77.7555 30.5508Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6058 87.8008L52.9195 89.2101C52.9195 89.2101 49.977 90.4913 48.0552 91.512C46.1334 92.5327 36.6653 99.8313 36.6653 99.8313L34.7477 99.9594L33.5947 100.728C33.5947 100.728 31.6729 101.113 31.6729 101.497C31.6729 101.881 32.0572 102.005 32.4416 102.005C33.0199 101.859 33.5789 101.646 34.1071 101.369C34.1071 101.369 32.8046 103.274 33.3171 103.274C34.0591 103.35 34.7962 103.469 35.525 103.628C36.3727 103.47 37.228 103.356 38.0874 103.286C38.728 103.286 40.2612 99.8313 40.2612 99.8313C40.2612 99.8313 51.2668 95.4795 52.6761 94.4545C54.0854 93.4296 58.1768 90.8714 58.1768 90.8714L55.6058 87.8008Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9363 77.2861L53.9399 88.1849L57.3992 92.2805L64.0529 89.7224L66.3548 77.4356L65.9363 77.2861Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5415 86.7324L53.9399 88.1845L57.3992 92.2801L59.4619 91.4857L55.5415 86.7324Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8747 145.484C86.8747 145.484 90.6842 149.447 91.0728 151.391C91.4615 153.334 90.5305 155.046 88.9759 154.577C87.4214 154.107 86.0206 149.294 85.632 148.44C85.2433 147.585 84.7778 146.65 84.7778 146.65C84.7778 146.65 85.9437 145.096 86.8747 145.484Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1076 151.601C91.3895 153.454 90.4713 155.017 88.9723 154.59C88.4299 154.432 87.9089 153.736 87.4434 152.882C88.4598 151.237 90.0955 151.327 91.1076 151.601Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9126 151.759C87.7667 152.924 88.8515 154.176 89.6715 153.958C90.4914 153.74 90.9228 152.198 91.0723 151.396C91.4566 153.334 90.5256 155.034 88.9753 154.569C88.2152 154.351 87.4977 153.091 86.9126 151.759Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0968 147.663C86.0968 147.663 87.8051 146.727 87.8862 147.039C87.9673 147.351 86.2548 148.205 86.0199 148.205C85.785 148.205 85.6313 148.128 86.0968 147.663Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M86.485 148.205C86.485 148.205 88.1932 147.274 88.2744 147.585C88.3555 147.897 86.643 148.751 86.4081 148.751C86.1732 148.751 86.0195 148.674 86.485 148.205Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8766 148.752C86.8766 148.752 88.5848 147.816 88.666 148.128C88.7471 148.44 87.0346 149.294 86.7997 149.294C86.5648 149.294 86.4111 149.217 86.8766 148.752Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2648 149.294C87.2648 149.294 88.973 148.363 89.0542 148.671C89.1353 148.978 87.4228 149.837 87.1879 149.837C86.953 149.837 86.7992 149.76 87.2648 149.294Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1827 149.051C56.1827 149.051 57.6689 151.122 57.8013 152.297C57.9337 153.471 56.9471 153.501 55.6915 153.368C54.436 153.236 52.937 154.163 51.1689 154.116C49.4008 154.069 47.3552 153.296 48.3374 152.455C49.3197 151.613 51.8821 150.921 52.4373 150.439C52.7687 150.149 53.0797 149.836 53.3683 149.503L56.1827 149.051Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3378 152.455C48.683 152.183 49.062 151.958 49.4652 151.784C49.9168 152.026 50.3141 152.358 50.6329 152.759C50.9516 153.16 51.185 153.622 51.3187 154.116H51.165C49.3969 154.069 47.3555 153.296 48.3378 152.455Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5968 150.165C52.5968 150.165 54.4204 151.117 53.9592 151.305C53.4979 151.493 52.1142 150.426 52.5968 150.165Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8883 150.357C51.8883 150.357 53.7119 151.31 53.2507 151.498C52.7894 151.686 51.4057 150.618 51.8883 150.357Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4796 150.639C51.4796 150.639 53.3032 151.591 52.842 151.779C52.3807 151.967 50.997 150.899 51.4796 150.639Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7353 150.98C50.7353 150.98 52.5589 151.933 52.0976 152.121C51.6364 152.309 50.2441 151.237 50.7353 150.98Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1312 152.714C49.4094 153.467 50.9305 153.692 52.372 153.342C53.7104 153.048 55.0698 152.86 56.4377 152.778C56.9031 152.765 57.3644 152.687 57.8086 152.548C57.7744 153.475 56.8519 153.492 55.6732 153.368C54.4176 153.231 52.9186 154.162 51.1506 154.115C49.5789 154.072 47.7853 153.449 48.1312 152.714Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8585 103.405C74.8585 103.405 73.9616 115.893 74.504 118.92C75.0464 121.948 76.3831 130.964 76.3831 130.964C76.3831 130.964 78.4074 132.441 80.4275 135.704C82.4475 138.967 86.8762 145.497 86.8762 145.497C86.8762 145.497 87.0342 146.663 85.6334 147.052C85.6334 147.052 84.9331 147.363 84.5444 147.052C84.1558 146.74 70.8782 134.462 69.3109 131.899C67.7435 129.337 65.6594 113.569 65.6594 113.569L63.6394 113.181L55.098 129.503L56.5842 149.345C56.5842 149.345 56.6995 150.028 55.7301 150.306C54.7606 150.583 53.9791 150.682 53.3983 150.182C52.8175 149.682 48.3204 127.953 48.7005 127.176C49.0806 126.398 57.6988 105.036 57.6988 105.036L58.395 103.251C58.395 103.251 66.5563 104.182 70.2077 103.482C73.8591 102.782 74.551 102.226 74.8585 103.405Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4641 105.822C73.4641 105.822 70.1842 107.915 73.4641 109.311",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3928 82.7862C80.4033 80.3605 76.6921 77.4308 76.6921 77.4308C76.6921 77.4308 68.8212 77.2514 65.9342 77.2856L61.877 90.2343C61.877 90.2343 58.1487 103.132 58.3025 103.678C58.4562 104.225 61.104 105.464 67.0104 106.164C72.9168 106.864 75.4023 104.379 75.5518 103.602C75.6162 102.897 75.5643 102.188 75.3981 101.5L77.4181 97.9258L84.1017 86.9331C84.5049 86.273 84.6552 85.4891 84.5249 84.7267C84.3946 83.9643 83.9924 83.2749 83.3928 82.7862Z",
    fill: "#F26531",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0581 80.8951C78.769 79.0587 76.7063 77.4316 76.7063 77.4316C76.7063 77.4316 74.0926 77.3718 71.3295 77.3291C70.6291 78.9263 69.4205 82.1892 70.4155 83.8035C71.6284 85.7936 75.6386 86.3872 81.0581 80.8951Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4999 64.1157C77.4999 64.1157 75.2492 64.7392 74.314 66.1357C73.3787 67.5323 70.6625 75.6978 70.7394 76.3854C70.8163 77.073 74.314 76.3854 74.314 76.3854C74.314 76.3854 71.9053 81.4376 71.9053 82.2918C71.9053 83.1459 72.9943 83.6157 74.3908 83.3039C75.7874 82.9922 80.5577 74.7924 80.5577 74.7924C80.5577 74.7924 81.9713 76.4324 82.8639 75.8687C83.8889 75.2238 83.5643 73.9255 82.787 73.9255C82.0097 73.9255 84.9608 70.7396 83.9529 68.6426C82.945 66.5457 78.4352 63.4196 77.4999 64.1157Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6456 61.634C76.6456 61.634 72.2937 61.634 72.0588 63.7309C71.8239 65.8278 74.0831 66.7631 76.5687 66.3745C79.0542 65.9859 81.3092 66.1396 81.6209 66.5282C81.9327 66.9169 78.5887 67.6941 79.366 68.2365C79.8178 68.561 80.3646 68.7262 80.9205 68.7063C80.9205 68.7063 79.8315 69.0138 79.9084 69.791C79.9852 70.5683 80.6643 74.0019 81.1896 74.0019C81.7149 74.0019 82.7697 73.9336 82.7697 73.9336C83.7536 73.4387 84.6473 72.7818 85.4133 71.9905C86.5792 70.7477 86.8867 68.1041 85.4133 66.5539C83.9399 65.0036 82.7697 63.496 81.6038 62.2533C80.4379 61.0105 79.3489 59.6909 77.0171 59.3791C74.6853 59.0673 73.4596 59.9983 76.6456 61.634Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7207 69.667C85.801 70.1223 85.8169 70.5867 85.7677 71.0464",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7363 64.085C77.7363 64.085 72.9659 64.5505 74.7468 65.4601C76.5277 66.3698 79.3079 64.6658 82.78 66.0409C83.3657 66.2525 83.9005 66.5845 84.35 67.0156C84.7995 67.4467 85.1535 67.9672 85.3894 68.5436",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6304 67.707C80.6304 67.707 83.8889 69.3 84.3203 71.6147",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3159 76.3973C74.3159 76.3973 78.0485 76.1666 79.0564 75.3125",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1479 73.2887C73.1479 73.2887 75.8684 74.066 76.6456 72.4346",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1807 72.123L77.3466 72.5928",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0029 69.7139C74.0029 69.7139 71.5942 70.0256 71.5942 70.4143C71.5942 70.8029 73.1488 71.8919 73.1488 71.8919",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0029 69.7139C74.0029 69.7139 71.5942 70.0256 71.5942 70.4143C71.5942 70.8029 73.1488 71.8919 73.1488 71.8919",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3112 68.9673C74.2002 69.3047 73.9738 69.531 73.803 69.4755C73.6322 69.42 73.5895 69.104 73.7048 68.7666C73.8201 68.4292 74.0422 68.2029 74.213 68.2584C74.3838 68.3139 74.4265 68.6342 74.3112 68.9673Z",
    fill: "#093269"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3595 70.0043C76.2442 70.3417 76.0178 70.568 75.8513 70.5125C75.6847 70.457 75.6377 70.1367 75.7488 69.8036C75.8598 69.4705 76.0904 69.2398 76.257 69.2954C76.4236 69.3509 76.4663 69.6669 76.3595 70.0043Z",
    fill: "#093269"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4683 67.7969C76.4683 67.7969 77.647 67.9036 77.5359 69.5052L76.4683 67.7969Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3999 67.049C75.3999 67.049 74.755 66.1948 73.9009 67.3693L75.3999 67.049Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9532 38.6232L42.7042 24.4658L31.4595 38.6232H35.8583V59.9382H49.5544V38.6232H53.9532Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9532 37.7052L42.7042 23.5479L31.4595 37.7052H35.8583V59.0202H49.5544V37.7052H53.9532Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6418 56.6162H18.8984V102.36H64.6418V56.6162Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5137 58.7432H21.0239V100.233H62.5137V58.7432Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3408_96122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0731 64.233V64.5013C30.0727 65.1303 29.8691 65.7423 29.4925 66.246C29.1159 66.7498 28.5865 67.1183 27.9834 67.2966C27.3802 67.475 26.7356 67.4536 26.1456 67.2356C25.5557 67.0176 25.0519 66.6148 24.7096 66.0872C24.3673 65.5595 24.2047 64.9354 24.2461 64.3078C24.2875 63.6802 24.5306 63.0828 24.9392 62.6047C25.3479 62.1265 25.9001 61.7933 26.5136 61.6547C27.1271 61.5161 27.769 61.5795 28.3435 61.8355",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0729 62.168L27.1563 65.0876L26.2812 64.2126",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 32.6562,
    y1: 64.126,
    x2: 59.6562,
    y2: 64.126,
    stroke: "white",
    strokeWidth: 0.75
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3408_96122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0731 74.233V74.5013C30.0727 75.1303 29.8691 75.7423 29.4925 76.246C29.1159 76.7498 28.5865 77.1183 27.9834 77.2966C27.3802 77.475 26.7356 77.4536 26.1456 77.2356C25.5557 77.0176 25.0519 76.6148 24.7096 76.0872C24.3673 75.5595 24.2047 74.9354 24.2461 74.3078C24.2875 73.6802 24.5306 73.0828 24.9392 72.6047C25.3479 72.1265 25.9001 71.7933 26.5136 71.6547C27.1271 71.5161 27.769 71.5795 28.3435 71.8355",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0729 72.168L27.1563 75.0876L26.2812 74.2126",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 32.6562,
    y1: 74.126,
    x2: 59.6562,
    y2: 74.126,
    stroke: "white",
    strokeWidth: 0.75
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3408_96122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0731 84.233V84.5013C30.0727 85.1303 29.8691 85.7423 29.4925 86.246C29.1159 86.7498 28.5865 87.1183 27.9834 87.2966C27.3802 87.475 26.7356 87.4536 26.1456 87.2356C25.5557 87.0176 25.0519 86.6148 24.7096 86.0872C24.3673 85.5595 24.2047 84.9354 24.2461 84.3078C24.2875 83.6802 24.5306 83.0828 24.9392 82.6047C25.3479 82.1265 25.9001 81.7933 26.5136 81.6547C27.1271 81.5161 27.769 81.5795 28.3435 81.8355",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0729 82.168L27.1563 85.0876L26.2812 84.2126",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 32.6562,
    y1: 84.126,
    x2: 59.6562,
    y2: 84.126,
    stroke: "white",
    strokeWidth: 0.75
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_3408_96122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0731 94.233V94.5013C30.0727 95.1303 29.8691 95.7423 29.4925 96.246C29.1159 96.7498 28.5865 97.1183 27.9834 97.2966C27.3802 97.475 26.7356 97.4536 26.1456 97.2356C25.5557 97.0176 25.0519 96.6148 24.7096 96.0872C24.3673 95.5595 24.2047 94.9354 24.2461 94.3078C24.2875 93.6802 24.5306 93.0828 24.9392 92.6047C25.3479 92.1265 25.9001 91.7933 26.5136 91.6547C27.1271 91.5161 27.769 91.5795 28.3435 91.8355",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0729 92.168L27.1563 95.0876L26.2812 94.2126",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 32.6562,
    y1: 94.126,
    x2: 59.6562,
    y2: 94.126,
    stroke: "white",
    strokeWidth: 0.75
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6797 84.7637L66.247 96.5166L48.8226 101.317C48.8226 101.317 47.2681 99.5104 46.1491 99.4976C45.0302 99.4848 41.4258 100.779 41.4258 100.779C41.4258 100.779 40.9688 101.898 41.8528 101.906C42.7618 101.842 43.6634 101.699 44.5476 101.479L39.6064 102.333C39.666 102.709 39.8571 103.052 40.1456 103.301C40.4341 103.55 40.8015 103.688 41.1823 103.691H43.4074L47.2125 104.174L50.8127 103.085C50.8127 103.085 67.8699 101.227 68.771 101.009C69.6721 100.792 84.1455 88.3681 84.1455 88.3681C84.1455 88.3681 85.7812 86.9289 85.1576 85.2591C84.5341 83.5892 81.3439 82.4062 81.3439 82.4062",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6797 84.7637L66.247 96.5166L48.8226 101.317C48.8226 101.317 47.2681 99.5104 46.1491 99.4976C45.0302 99.4847 41.4258 100.779 41.4258 100.779C41.4258 100.779 40.9688 101.898 41.8528 101.906C42.7618 101.842 43.6634 101.699 44.5476 101.479L39.6064 102.333C39.666 102.709 39.8571 103.052 40.1456 103.301C40.4341 103.55 40.8015 103.688 41.1823 103.691H43.4074L47.2125 104.174L50.8127 103.085C50.8127 103.085 67.8699 101.227 68.771 101.009C69.6721 100.792 84.1455 88.3681 84.1455 88.3681C84.1455 88.3681 85.7812 86.9289 85.1576 85.2591C84.5341 83.5892 81.3439 82.4062 81.3439 82.4062",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6179 85.9895L66.9014 94.7317L73.3715 99.3995L84.6119 88.8125C85.1605 88.2987 85.5169 87.6128 85.6218 86.8685C85.7267 86.1242 85.5738 85.3665 85.1885 84.7211L85.15 84.6614C84.3439 83.3831 83.2039 82.3494 81.8531 81.6719",
    fill: "#F26531"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6179 85.9895L66.9014 94.7317L73.3715 99.3995L84.6119 88.8125C85.1605 88.2987 85.5169 87.6128 85.6218 86.8685C85.7267 86.1242 85.5738 85.3665 85.1885 84.7211L85.15 84.6614C84.3439 83.3831 83.2039 82.3494 81.8531 81.6719",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3885 99.4L74.9089 97.9651L68.4046 93.2246L66.9014 94.7322L73.3885 99.4Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6729 101.497L33.3171 103.273L34.91 103.448L32.4373 101.33L31.6729 101.497Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7651 101.497L36.4093 103.273L37.998 103.448L35.5253 101.33L34.7651 101.497Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M34.909 103.448L33.0513 101.064H34.2001L36.4977 103.448L35.524 103.627L34.909 103.448Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0239 101.684L31.8183 103.183L33.3173 103.273L31.6731 101.496L31.0239 101.684Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3408_96122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    fill: "white",
    transform: "translate(23.6562 61.001)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3408_96122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    fill: "white",
    transform: "translate(23.6562 71.001)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3408_96122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    fill: "white",
    transform: "translate(23.6562 81.001)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_3408_96122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    fill: "white",
    transform: "translate(23.6562 91.001)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadguy);
export default __webpack_public_path__ + "static/media/Uploadguy.42ef76266cd428a4376cb6829b315593.svg";
export { ForwardRef as ReactComponent };